import React, { useState } from 'react';
import { Check } from 'lucide-react';
import Home from '../home/Home';
import { TEST_USERS, CHAPTERS } from '../../data/testData';

const TestModeLayout = ({ profile, logOut, userId, creditsLeft, onCreditUsed }) => {
  const chapterKeys = Array.isArray(TEST_USERS[userId])
    ? TEST_USERS[userId]
    : [TEST_USERS[userId]];

  const [selectedChapterKey, setSelectedChapterKey] = useState(chapterKeys[0]);
  const chapter = CHAPTERS[selectedChapterKey];
  const [activePart, setActivePart] = useState(0);
  const [completedParts, setCompletedParts] = useState(new Set());

  if (!chapter) return null;

  const handleChapterChange = (key) => {
    setSelectedChapterKey(key);
    setActivePart(0);
    setCompletedParts(new Set());
  };

  const currentPart = chapter.parts[activePart];

  const handlePartComplete = () => {
    setCompletedParts(prev => new Set([...prev, activePart]));
  };

  return (
    <div>
      {/* Tab bar — fixed just below the 64px navbar */}
      <div style={{
        position: "fixed",
        top: "64px",
        left: 0,
        width: "100%",
        height: "46px",
        display: "flex",
        alignItems: "center",
        gap: "6px",
        padding: "0 16px",
        background: "rgba(8, 22, 40, 0.88)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        zIndex: 999,
        boxSizing: "border-box",
        overflowX: "auto",
      }}>
        {chapterKeys.length > 1 && (
          <select
            value={selectedChapterKey}
            onChange={e => handleChapterChange(e.target.value)}
            style={{
              flexShrink: 0,
              marginRight: "10px",
              padding: "4px 10px",
              borderRadius: "20px",
              border: "1px solid rgba(99,179,237,0.5)",
              background: "rgba(99,179,237,0.15)",
              color: "rgba(99,179,237,0.95)",
              fontSize: "12px",
              fontWeight: 600,
              letterSpacing: "0.5px",
              cursor: "pointer",
              outline: "none",
              appearance: "none",
              WebkitAppearance: "none",
              paddingRight: "24px",
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='rgba(99,179,237,0.8)'/%3E%3C/svg%3E\")",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 8px center",
            }}
          >
            {chapterKeys.map(key => (
              <option key={key} value={key} style={{ background: "#0a1929", color: "white" }}>
                {CHAPTERS[key]?.title ?? key}
              </option>
            ))}
          </select>
        )}
        {chapter.parts.map((part, idx) => {
          const isActive = idx === activePart;
          const isDone = completedParts.has(idx);
          return (
            <button
              key={idx}
              onClick={() => setActivePart(idx)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                padding: "5px 14px",
                borderRadius: "20px",
                border: isActive
                  ? "1px solid rgba(99,179,237,0.6)"
                  : "1px solid rgba(255,255,255,0.12)",
                background: isActive
                  ? "rgba(99,179,237,0.2)"
                  : "rgba(255,255,255,0.06)",
                color: isActive
                  ? "rgba(99,179,237,0.95)"
                  : "rgba(255,255,255,0.6)",
                fontSize: "12px",
                fontWeight: isActive ? 700 : 500,
                letterSpacing: "0.5px",
                cursor: "pointer",
                flexShrink: 0,
                transition: "all 0.2s",
              }}
            >
              {part.title}
              {isDone && (
                <span style={{ color: "rgba(72,199,142,0.9)", display: "flex", alignItems: "center" }}>
                  <Check size={11} />
                </span>
              )}
            </button>
          );
        })}
      </div>

      <Home
        profile={profile}
        logOut={logOut}
        userId={userId}
        creditsLeft={creditsLeft}
        onCreditUsed={onCreditUsed}
        testMode={true}
        initialScreenplay={currentPart.screenplay}
        initialBackground={currentPart.backgroundImage}
        testModeTopic={currentPart.title}
        onPartComplete={handlePartComplete}
      />
    </div>
  );
};

export default TestModeLayout;
